import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../reducers/types";
import { PackagesSearch } from "./component";
import {
  getFetchRewardsAccountsCallState,
  getRewardsAccountWithLargestEarnForBanner,
} from "../rewards/reducer";
import { fetchRewardsAccounts } from "../rewards/actions/actions";
import { resetPackagesAvailabilityCallState } from "../availability/actions/actions";
import {
  setDepartureDate,
  setReturnDate,
  setOrigin,
  setDestination,
  setStopsOption,
  setFareclassOptionFilter,
  setTravelers,
} from "./actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  fetchRewardsAccountsCallState: getFetchRewardsAccountsCallState(state),
});

const mapDispatchToProps = {
  fetchRewardsAccounts,
  resetPackagesAvailabilityCallState,
  setDepartureDate,
  setReturnDate,
  setOrigin,
  setDestination,
  setStopsOption,
  setFareclassOptionFilter,
  setTravelers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesSearchConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPackagesSearch = withRouter(connector(PackagesSearch));
